import { render, staticRenderFns } from "./AwardEmptyDefaultLayout.vue?vue&type=template&id=4ccb37d7&scoped=true&"
import script from "./AwardEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./AwardEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb37d7",
  null
  
)

export default component.exports